<template>
  <v-dialog v-model="dialog" scrollable width="1300">
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title class="d-flex align-center">
          <v-icon left>mdi-file-document-outline</v-icon>
          Biên bản kiểm kê {{ item.code }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6">
        <!-- Khung tiêu đề văn bản Mẫu số 05 - VT -->
        <div class="d-flex justify-space-between align-start mb-2">
          <div>
            <div class="text-caption font-weight-bold">ĐƠN VỊ: TRƯỜNG HỌC / TRUNG TÂM</div>
            <div class="text-caption">BỘ PHẬN: QUẢN LÝ CƠ SỞ VẬT CHẤT & THIẾT BỊ</div>
          </div>
          <div class="text-right">
            <div class="text-subtitle-2 font-weight-bold">Mẫu số 05 - VT</div>
            <div class="text-caption grey--text">(Ban hành theo Thông tư số 133/2014/TT-BTC & 200/2014/TT-BTC)</div>
          </div>
        </div>

        <div class="text-center my-4">
          <h2 class="primary--text font-weight-bold text-uppercase">
            BIÊN BẢN KIỂM KÊ VẬT TƯ, CÔNG CỤ, SẢN PHẨM, HÀNG HOÁ, TÀI SẢN
          </h2>
          <div class="text-subtitle-2 font-weight-medium mt-1">
            {{ item.title }}
          </div>
          <div class="text-caption grey--text text--darken-1 mt-1">
            Thời điểm kiểm kê: <strong>{{ item.auditTime || '08:00' }}</strong> ngày <strong>{{ item.auditDate }}</strong>
          </div>
        </div>

        <!-- Ban kiểm kê -->
        <div class="pa-3 grey lighten-4 rounded mb-4">
          <div class="text-subtitle-2 font-weight-bold mb-2 primary--text">BAN KIỂM KÊ:</div>
          <v-row dense>
            <v-col cols="12" md="4">
              <span>Trưởng ban kiểm kê: </span>
              <strong class="primary--text">{{ item.auditor || '-' }}</strong>
            </v-col>
            <v-col cols="12" md="4">
              <span>Kế toán trưởng / Đại diện: </span>
              <strong class="teal--text">{{ item.approver || '-' }}</strong>
            </v-col>
            <v-col cols="12" md="4">
              <span>Thủ kho / Người quản lý: </span>
              <strong class="deep-orange--text">{{ item.manager || '-' }}</strong>
            </v-col>
          </v-row>
        </div>

        <!-- Bảng kiểm kê MISA -->
        <div class="table-responsive-wrapper mb-4">
          <v-simple-table dense class="elevation-1 misa-detail-table">
            <template v-slot:default>
              <thead>
                <tr class="misa-header-row-1 text-center">
                  <th rowspan="2" class="text-center" style="width: 35px">#</th>
                  <th rowspan="2" style="min-width: 140px" class="font-weight-bold">Mã đầu mục</th>
                  <th rowspan="2" style="min-width: 220px" class="font-weight-bold">Tên đầu mục</th>
                  <th rowspan="2" style="min-width: 75px" class="text-center font-weight-bold">ĐVT</th>
                  <th colspan="3" class="text-center font-weight-bold misa-group-qty">
                    Số lượng
                  </th>
                  <th colspan="3" class="text-center font-weight-bold misa-group-quality">
                    Phẩm chất
                  </th>
                  <th rowspan="2" style="min-width: 160px" class="text-center font-weight-bold">Đề xuất xử lý</th>
                </tr>
                <tr class="misa-header-row-2 text-center">
                  <th class="text-center font-weight-medium">Theo sổ sách</th>
                  <th class="text-center font-weight-bold blue--text text--darken-3">Theo kiểm kê</th>
                  <th class="text-center font-weight-medium">Chênh lệch</th>
                  <th class="text-center font-weight-medium green--text text--darken-3" style="min-width: 125px">Còn tốt 100%</th>
                  <th class="text-center font-weight-medium orange--text text--darken-3" style="min-width: 125px">Kém phẩm chất</th>
                  <th class="text-center font-weight-medium red--text text--darken-3" style="min-width: 125px">Mất phẩm chất</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(it, idx) in item.items || []" :key="idx">
                  <td class="text-center grey--text text-caption">{{ idx + 1 }}</td>
                  <td><strong>{{ it.categoryCode || it.assetCode || '-' }}</strong></td>
                  <td>{{ it.categoryName || it.assetName || '-' }}</td>
                  <td class="text-center">
                    <v-chip x-small outlined color="primary">{{ it.unit || '-' }}</v-chip>
                  </td>
                  <td class="text-right font-weight-medium">{{ formatNumber(it.systemQuantity) }}</td>
                  <td class="text-right font-weight-bold blue--text text--darken-3">{{ formatNumber(it.actualQuantity) }}</td>
                  <td class="text-right font-weight-bold" :class="it.diff < 0 ? 'red--text' : (it.diff > 0 ? 'green--text' : '')">
                    {{ formatDiff(it.diff) }}
                  </td>

                  <!-- Còn tốt 100% + nút ... -->
                  <td class="text-right">
                    <div class="d-flex align-center justify-end">
                      <span class="green--text text--darken-3 font-weight-medium">{{ formatNumber(it.qtyGood != null ? it.qtyGood : (it.actualQuantity - (it.qtyDegraded || 0) - (it.qtyBad || 0))) }}</span>
                      <v-btn
                        icon
                        x-small
                        color="primary"
                        class="ml-1"
                        @click="openSubAssetsDialog(it, 'AVAILABLE')"
                      >
                        <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>

                  <!-- Kém phẩm chất + nút ... -->
                  <td class="text-right">
                    <div class="d-flex align-center justify-end">
                      <span class="orange--text text--darken-3 font-weight-medium">{{ formatNumber(it.qtyDegraded || it.qtyUsed || 0) }}</span>
                      <v-btn
                        icon
                        x-small
                        color="primary"
                        class="ml-1"
                        @click="openSubAssetsDialog(it, 'MAINTENANCE')"
                      >
                        <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>

                  <!-- Mất phẩm chất + nút ... -->
                  <td class="text-right">
                    <div class="d-flex align-center justify-end">
                      <span class="red--text text--darken-3 font-weight-medium">{{ formatNumber(it.qtyBad || it.qtyBroken || 0) }}</span>
                      <v-btn
                        icon
                        x-small
                        color="primary"
                        class="ml-1"
                        @click="openSubAssetsDialog(it, 'BROKEN')"
                      >
                        <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>

                  <td class="text-center">
                    <v-chip x-small :color="getActionColor(it.action || (it.diff < 0 ? 'Xuất kho thanh lý' : (it.diff > 0 ? 'Nhập kho bổ sung' : 'Không xử lý')))" dark>
                      {{ it.action || (it.diff < 0 ? 'Xuất kho thanh lý' : (it.diff > 0 ? 'Nhập kho bổ sung' : 'Không xử lý')) }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="misa-footer-row font-weight-bold">
                  <td colspan="4" class="px-3 font-weight-bold text-uppercase">
                    Tổng cộng
                  </td>
                  <td class="text-right font-weight-bold">{{ formatNumber(totals.systemQty) }}</td>
                  <td class="text-right font-weight-bold blue--text text--darken-3">{{ formatNumber(totals.actualQty) }}</td>
                  <td class="text-right font-weight-bold" :class="totals.diff < 0 ? 'red--text' : (totals.diff > 0 ? 'green--text' : '')">
                    {{ formatDiff(totals.diff) }}
                  </td>
                  <td class="text-right font-weight-bold green--text text--darken-3">{{ formatNumber(totals.goodQty) }}</td>
                  <td class="text-right font-weight-bold">{{ formatNumber(totals.degradedQty) }}</td>
                  <td class="text-right font-weight-bold">{{ formatNumber(totals.badQty) }}</td>
                  <td></td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </div>

        <!-- Ý kiến giải quyết số chênh lệch / Kết luận -->
        <div class="pa-4 grey lighten-4 rounded mb-6">
          <div class="text-subtitle-2 font-weight-bold mb-1 primary--text">
            Ý KIẾN GIẢI QUYẾT SỐ CHÊNH LỆCH VÀ KẾT LUẬN:
          </div>
          <div class="text-body-2">
            {{ item.conclusion || 'Đã đối soát hoàn tất số liệu kiểm kê thực tế khớp với hồ sơ quản lý tài sản.' }}
          </div>
        </div>

        <!-- Chân chữ ký 4 bên -->
        <v-row class="text-center mt-2">
          <v-col cols="3">
            <div class="font-weight-bold text-uppercase">Giám đốc</div>
            <div class="text-caption grey--text">(Ý kiến giải quyết số chênh lệch)</div>
            <div class="text-caption grey--text">(Ký, họ tên)</div>
            <div style="height: 60px;"></div>
            <div class="font-weight-medium">Ban Giám Đốc</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-bold text-uppercase">Kế toán trưởng</div>
            <div class="text-caption grey--text">(Ký, họ tên)</div>
            <div style="height: 75px;"></div>
            <div class="font-weight-medium">{{ item.approver || '-' }}</div>
          </v-col>
          <v-col cols="3">
            <div class="font-weight-bold text-uppercase">Thủ kho</div>
            <div class="text-caption grey--text">(Ký, họ tên)</div>
            <div style="height: 75px;"></div>
            <div class="font-weight-medium">{{ item.manager || '-' }}</div>
          </v-col>
          <v-col cols="3">
            <div class="text-caption grey--text">Ngày {{ item.auditDate }}</div>
            <div class="font-weight-bold text-uppercase">Trưởng ban kiểm kê</div>
            <div class="text-caption grey--text">(Ký, họ tên)</div>
            <div style="height: 60px;"></div>
            <div class="font-weight-medium primary--text">{{ item.auditor || '-' }}</div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-chip :color="getStatusColor(item.status)" dark class="font-weight-medium">
          {{ getStatusLabel(item.status) }}
        </v-chip>
        <v-spacer />
        <v-btn v-if="item.status !== 'COMPLETED'" color="success" depressed @click="onComplete">
          <v-icon left>mdi-check-decagram</v-icon> Hoàn tất & Khóa biên bản
        </v-btn>
        <v-btn outlined @click="dialog = false">Đóng</v-btn>
      </v-card-actions>
    </v-card>

    <!-- DIALOG CHI TIẾT SẢN PHẨM KIỂM KÊ TRONG DETAIL (PHÓNG TO) -->
    <v-dialog v-model="subAssetsDialog" max-width="1500px" width="94vw" scrollable>
      <v-card v-if="selectedRow">
        <v-toolbar color="primary" dense dark class="elevation-0 py-1">
          <v-icon left>mdi-format-list-bulleted-square</v-icon>
          <v-toolbar-title class="text-h6 font-weight-bold">
            Chi tiết: {{ selectedRow.categoryCode || selectedRow.assetCode || 'Mã đầu mục' }} - {{ selectedRow.categoryName || selectedRow.assetName || 'Thiết bị' }} - {{ selectedRow.unit || 'Chiếc' }} - {{ getQualityConditionLabel(selectedQualityType) }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="subAssetsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Thông tin tóm tắt -->
        <div class="px-5 py-3 grey lighten-4 d-flex justify-space-between align-center flex-wrap">
          <div class="text-body-1 grey--text text--darken-3 font-weight-medium">
            Danh sách các sản phẩm/thiết bị chi tiết thuộc danh mục <strong class="primary--text">{{ selectedRow.categoryName || selectedRow.assetName }}</strong>
          </div>
          <v-chip color="primary" outlined class="font-weight-bold text-subtitle-2 px-3 py-1">
            Tổng số lượng: {{ getFilteredSubAssets(selectedRow, selectedQualityType).length }} {{ selectedRow.unit || 'sản phẩm' }}
          </v-chip>
        </div>

        <v-card-text class="pa-5" style="max-height: 600px; overflow-y: auto;">
          <v-simple-table dense class="elevation-1 sub-assets-table">
            <template v-slot:default>
              <thead>
                <tr class="blue lighten-5">
                  <th class="text-center" style="width: 45px">#</th>
                  <th style="min-width: 200px">Mã sản phẩm</th>
                  <th style="min-width: 240px">Tên sản phẩm</th>
                  <th style="min-width: 180px">Vị trí</th>
                  <th class="text-center" style="min-width: 100px">Mã QR</th>
                  <th class="text-center" style="min-width: 140px">Hình ảnh</th>
                  <th class="text-center" style="min-width: 160px">Trạng thái</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!getFilteredSubAssets(selectedRow, selectedQualityType).length">
                  <td colspan="7" class="text-center py-8 grey--text text-body-1">
                    <v-icon medium color="grey" class="mr-2">mdi-information-outline</v-icon>
                    Không có sản phẩm nào thuộc tình trạng {{ getQualityConditionLabel(selectedQualityType) }} trong hệ thống.
                  </td>
                </tr>
                <tr v-for="(sub, sIdx) in getFilteredSubAssets(selectedRow, selectedQualityType)" :key="sIdx">
                  <td class="text-center grey--text font-weight-medium" style="font-size: 14.5px;">{{ sIdx + 1 }}</td>
                  <td class="font-weight-medium primary--text" style="font-size: 14.5px;">{{ sub.code || '-' }}</td>
                  <td style="font-size: 14.5px;">{{ sub.name || '-' }}</td>
                  <td style="font-size: 14.5px;">{{ sub.location || '-' }}</td>
                  <td class="text-center py-2">
                    <div class="d-flex align-center justify-center">
                      <img
                        :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodeURIComponent(sub.code || sub.id || '')"
                        alt="QR Code"
                        style="width: 48px; height: 48px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 2px; background: white;"
                      />
                    </div>
                  </td>
                  <!-- Cột Hình ảnh -->
                  <td class="text-center py-2">
                    <div class="d-flex align-center justify-center flex-wrap" v-if="sub.images && sub.images.length">
                      <v-avatar
                        v-for="(img, imgIdx) in sub.images.slice(0, 3)"
                        :key="imgIdx"
                        size="34"
                        rounded
                        class="mr-1 elevation-1"
                        style="cursor: pointer; border: 1px solid #90caf9;"
                        @click="previewImage(getImageUrl(img))"
                      >
                        <v-img :src="getImageUrl(img)" />
                      </v-avatar>
                      <v-chip
                        v-if="sub.images.length > 3"
                        x-small
                        color="primary"
                        class="font-weight-bold"
                        style="cursor: pointer;"
                        @click="previewImage(getImageUrl(sub.images[0]))"
                      >
                        +{{ sub.images.length - 3 }}
                      </v-chip>
                    </div>
                    <span v-else class="text-caption grey--text font-italic">Không có ảnh</span>
                  </td>
                  <td class="text-center font-weight-medium" style="font-size: 14.5px;">
                    <v-chip x-small :color="getAssetStatusColor(sub.status)" dark>
                      {{ getAssetStatusLabel(sub.status) }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider />
        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer />
          <v-btn color="primary" depressed large class="px-6 font-weight-medium" @click="subAssetsDialog = false">
            Đóng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog phóng to ảnh -->
    <v-dialog v-model="previewDialog" max-width="800px">
      <v-card v-if="previewImageUrl" class="pa-2">
        <v-img :src="previewImageUrl" max-height="80vh" contain />
        <v-card-actions class="pa-2">
          <v-spacer />
          <v-btn text color="primary" @click="previewDialog = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'

export default {
  name: 'AuditDetailDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false,
      subAssetsDialog: false,
      previewDialog: false,
      previewImageUrl: '',
      selectedRow: null,
      selectedQualityType: 'ALL'
    }
  },
  computed: {
    totals() {
      if (!this.item || !Array.isArray(this.item.items)) {
        return {
          systemQty: 0,
          actualQty: 0,
          diff: 0,
          goodQty: 0,
          degradedQty: 0,
          badQty: 0
        }
      }

      let systemQty = 0
      let actualQty = 0
      let goodQty = 0
      let degradedQty = 0
      let badQty = 0

      this.item.items.forEach(it => {
        const sys = Number(it.systemQuantity) || 0
        const act = Number(it.actualQuantity) || 0
        const deg = Number(it.qtyDegraded || it.qtyUsed) || 0
        const bad = Number(it.qtyBad || it.qtyBroken) || 0
        const good = Number(it.qtyGood != null ? it.qtyGood : (act - deg - bad)) || 0

        systemQty += sys
        actualQty += act
        goodQty += good
        degradedQty += deg
        badQty += bad
      })

      return {
        systemQty,
        actualQty,
        diff: actualQty - systemQty,
        goodQty,
        degradedQty,
        badQty
      }
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    get,
    ...mapActions('FacilityAudits', ['updateAudit']),
    formatNumber(val) {
      if (val === null || val === undefined || isNaN(val)) return '0,00'
      return Number(val).toLocaleString('vi-VN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    formatDiff(diff) {
      if (diff === null || diff === undefined || isNaN(diff)) return '0,00'
      const num = Number(diff)
      if (num < 0) {
        return `(${Math.abs(num).toLocaleString('vi-VN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })})`
      }
      return num.toLocaleString('vi-VN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    openSubAssetsDialog(it, qualityType = 'ALL') {
      this.selectedRow = it
      this.selectedQualityType = qualityType
      this.subAssetsDialog = true
    },
    getSubAssets(row) {
      if (!row) return []
      if (Array.isArray(row.subAssets) && row.subAssets.length) {
        return row.subAssets
      }
      return []
    },
    getFilteredSubAssets(row, type) {
      const allSub = this.getSubAssets(row)
      if (!type || type === 'ALL') return allSub
      if (type === 'MAINTENANCE') {
        return allSub.filter(s => s.status === 'MAINTENANCE' || s.status === 'BORROWED')
      }
      return allSub.filter(s => s.status === type)
    },
    getDialogTitle(type) {
      switch (type) {
        case 'AVAILABLE': return 'Chi tiết sản phẩm Còn tốt 100%'
        case 'MAINTENANCE': return 'Chi tiết sản phẩm Kém phẩm chất'
        case 'BROKEN': return 'Chi tiết sản phẩm Mất phẩm chất / Hỏng'
        default: return 'Chi tiết toàn bộ sản phẩm kiểm kê'
      }
    },
    getDialogHeaderColor(type) {
      switch (type) {
        case 'AVAILABLE': return 'green darken-2'
        case 'MAINTENANCE': return 'orange darken-3'
        case 'BROKEN': return 'red darken-2'
        default: return 'primary'
      }
    },
    getDialogHeaderIcon(type) {
      switch (type) {
        case 'AVAILABLE': return 'mdi-check-circle'
        case 'MAINTENANCE': return 'mdi-alert-circle'
        case 'BROKEN': return 'mdi-close-circle'
        default: return 'mdi-format-list-bulleted-square'
      }
    },
    getAssetStatusLabel(status) {
      switch (status) {
        case 'AVAILABLE': return 'Sẵn sàng sử dụng'
        case 'BORROWED': return 'Đang mượn'
        case 'MAINTENANCE': return 'Đang bảo dưỡng / Kém phẩm chất'
        case 'BROKEN': return 'Hỏng / Mất phẩm chất'
        default: return status || 'Sẵn sàng'
      }
    },
    getAssetStatusColor(status) {
      switch (status) {
        case 'AVAILABLE': return 'success'
        case 'BORROWED': return 'primary'
        case 'MAINTENANCE': return 'warning'
        case 'BROKEN': return 'error'
        default: return 'grey'
      }
    },
    getActionColor(action) {
      const act = String(action || '').toLowerCase()
      if (act.includes('xuất kho') || act.includes('thanh lý')) return 'error'
      if (act.includes('nhập kho') || act.includes('bổ sung')) return 'success'
      if (act.includes('sửa') || act.includes('bảo dưỡng')) return 'warning'
      if (act.includes('điều chuyển')) return 'indigo'
      return 'blue-grey'
    },
    getQualityConditionLabel(type) {
      switch (type) {
        case 'AVAILABLE': return 'Còn tốt 100%'
        case 'MAINTENANCE': return 'Kém phẩm chất'
        case 'BROKEN': return 'Mất phẩm chất / Hỏng'
        default: return 'Tất cả'
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'DRAFT': return 'Bản nháp'
        case 'IN_PROGRESS': return 'Đang kiểm kê'
        case 'COMPLETED': return 'Đã hoàn thành'
        default: return status
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'DRAFT': return 'blue-grey'
        case 'IN_PROGRESS': return 'primary'
        case 'COMPLETED': return 'success'
        default: return 'grey'
      }
    },
    async onComplete() {
      const conc = prompt('Nhập kết luận kiểm kê:', this.item.conclusion || 'Đã đối soát xong.')
      if (conc !== null) {
        await this.updateAudit({
          id: this.item.id,
          status: 'COMPLETED',
          conclusion: conc
        })
        this.dialog = false
        this.$emit('updated')
      }
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewDialog = true
    },
    getImageUrl(img) {
      if (!img) return ''
      const url = typeof img === 'string' ? img : (img.url || '')
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//') || url.startsWith('data:')) {
        return url
      }
      const apiBase = process.env.VUE_APP_API_URL || ''
      return apiBase.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
    }
  }
}
</script>

<style scoped>
.table-responsive-wrapper {
  width: 100%;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
}
.table-responsive-wrapper >>> .v-data-table__wrapper {
  overflow: visible !important;
}
.misa-detail-table {
  border-collapse: separate !important;
  border-spacing: 0;
}
.misa-detail-table th,
.misa-detail-table td {
  border: 1px solid #d0d7de !important;
  font-size: 13px !important;
}
.misa-header-row-1 th {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  background-color: #e3f2fd !important;
  color: #1565c0 !important;
}
.misa-header-row-2 th {
  position: sticky !important;
  top: 32px !important;
  z-index: 10 !important;
  background-color: #e3f2fd !important;
  color: #1565c0 !important;
}
.misa-group-qty {
  background-color: #bbdefb !important;
}
.misa-group-quality {
  background-color: #c5cae9 !important;
}
.misa-footer-row td {
  position: sticky !important;
  bottom: 0 !important;
  z-index: 9 !important;
  background-color: #eceff1 !important;
  box-shadow: 0 -1px 0 #b0bec5, 0 1px 0 #b0bec5;
}
.sub-assets-table {
  border-collapse: separate !important;
  border-spacing: 0;
  font-size: 14.5px !important;
}
.sub-assets-table th,
.sub-assets-table td {
  border: 1px solid #d0d7de !important;
  font-size: 14.5px !important;
  font-family: inherit !important;
  padding: 8px 12px !important;
}
.sub-assets-table th {
  font-weight: 700 !important;
  font-size: 15px !important;
  color: #1565c0 !important;
}
</style>
